import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  subtitle: {
    font: "700 16px/18px Manrope",
    color: "#465869",
  },
  container: {
    position: "relative",
    paddingBottom: "40px",
  },
  gridHeight: {
    height: "100%",
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
}));

export default styles;
